export interface Country {
  // ISO 3166-1 alpha-3 — used by rate-card data models and quote generation throughout the platform.
  // The internal Postcodes/Resolve cache uses alpha-2, so callers convert via toAlpha2() before calling.
  code: string
  name: string
}

export const COUNTRIES: Country[] = [
  { code: "GBR", name: "United Kingdom" },
  { code: "IRL", name: "Ireland" },
  { code: "FRA", name: "France" },
  { code: "DEU", name: "Germany" },
  { code: "NLD", name: "Netherlands" },
  { code: "BEL", name: "Belgium" },
  { code: "ESP", name: "Spain" },
  { code: "ITA", name: "Italy" },
  { code: "POL", name: "Poland" },
  { code: "PRT", name: "Portugal" },
  { code: "AUT", name: "Austria" },
  { code: "CHE", name: "Switzerland" },
  { code: "DNK", name: "Denmark" },
  { code: "SWE", name: "Sweden" },
  { code: "NOR", name: "Norway" },
  { code: "FIN", name: "Finland" },
  { code: "CZE", name: "Czech Republic" },
  { code: "HUN", name: "Hungary" },
  { code: "GRC", name: "Greece" },
  { code: "ROU", name: "Romania" },
  { code: "BGR", name: "Bulgaria" },
  { code: "HRV", name: "Croatia" },
  { code: "SVK", name: "Slovakia" },
  { code: "SVN", name: "Slovenia" },
  { code: "LTU", name: "Lithuania" },
  { code: "LVA", name: "Latvia" },
  { code: "EST", name: "Estonia" },
  { code: "LUX", name: "Luxembourg" },
  { code: "MLT", name: "Malta" },
  { code: "CYP", name: "Cyprus" },
  { code: "USA", name: "United States" },
  { code: "CAN", name: "Canada" },
  { code: "AUS", name: "Australia" },
  { code: "NZL", name: "New Zealand" },
  { code: "ZAF", name: "South Africa" },
  { code: "ARE", name: "United Arab Emirates" },
  { code: "SAU", name: "Saudi Arabia" },
  { code: "SGP", name: "Singapore" },
  { code: "HKG", name: "Hong Kong" },
  { code: "JPN", name: "Japan" },
  { code: "CHN", name: "China" },
  { code: "IND", name: "India" },
  { code: "BRA", name: "Brazil" },
  { code: "MEX", name: "Mexico" },
]

export const DEFAULT_COUNTRY: Country = { code: "GBR", name: "United Kingdom" }

// alpha-3 → alpha-2 mapping for the GeoNames-backed Postcodes/Resolve cache.
const ALPHA3_TO_ALPHA2: Record<string, string> = {
  GBR: "GB", IRL: "IE", FRA: "FR", DEU: "DE", NLD: "NL", BEL: "BE", ESP: "ES", ITA: "IT",
  POL: "PL", PRT: "PT", AUT: "AT", CHE: "CH", DNK: "DK", SWE: "SE", NOR: "NO", FIN: "FI",
  CZE: "CZ", HUN: "HU", GRC: "GR", ROU: "RO", BGR: "BG", HRV: "HR", SVK: "SK", SVN: "SI",
  LTU: "LT", LVA: "LV", EST: "EE", LUX: "LU", MLT: "MT", CYP: "CY", USA: "US", CAN: "CA",
  AUS: "AU", NZL: "NZ", ZAF: "ZA", ARE: "AE", SAU: "SA", SGP: "SG", HKG: "HK", JPN: "JP",
  CHN: "CN", IND: "IN", BRA: "BR", MEX: "MX",
}

/**
 * Converts an ISO 3166-1 alpha-3 code (rate-card format) to alpha-2 (GeoNames / Postcodes cache format).
 * Returns the input as-is if it's already 2 chars or not in the mapping table.
 */
export function toAlpha2(code: string | null | undefined): string {
  const upper = (code ?? "").trim().toUpperCase()
  if (upper.length === 2) return upper
  return ALPHA3_TO_ALPHA2[upper] ?? upper
}

export function getCountryByCode(code: string): Country | undefined {
  return COUNTRIES.find((c) => c.code === code)
}

export function getCountryByName(name: string): Country | undefined {
  return COUNTRIES.find((c) => c.name === name)
}

export function getCountryNames(): string[] {
  return COUNTRIES.map((c) => c.name)
}
